import React, { Component } from 'react';
import { COLORS } from '../pages/theme';
import { ExitToApp, ArrowForwardIos } from '@material-ui/icons';
import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import { CountAmountStatsSmall } from './custom_stat';
import { formatMoney } from '../lib/util';
import moment from 'moment';

const queryString = require('query-string');

const LEFT_RIGHT_PADDING = 12;
const TOP_BOTTOM_PADDING = 8;

class SourceMapItem extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: this.props.data || {},
            expanded_indexes: []
        }
    }

    onExpand = (index) => {
        this.setState({
            expanded_indexes: this.state.expanded_indexes.includes(index) ? [] : [index]
        })
    }

    render() {
        let data = this.props.data || {};
        let reconcilers = data.reconcilers || [];
        let labels = data.labels || [];
        const { expanded_indexes } = this.state;

        return (
            <div className='default-card' style={{
                flex: 1
            }}>

                <div style={{
                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING,
                    paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                    borderBottom: `1px solid ${COLORS.border_basic}`,
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                        alignItems: 'center'
                    }}>
                        <div className='card-title'
                            title={data.name}
                            style={{
                                wordBreak: 'break-all',
                                marginRight: 8
                            }}>{data.name}</div>
                        <Link to={{
                            pathname: `/processors/groups/${this.props.group_id}/sources/${data.id}`
                        }}>
                            <ExitToApp titleAccess="View More" className='basic-icon hand-cursor' />
                        </Link>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                    }}>
                        {labels.map((item) => {
                            return <Tag closable onClose={(e) => {
                                e.preventDefault()
                                typeof this.props.onRemoveLabel === 'function' &&
                                    this.props.onRemoveLabel(item.id)
                                // let flags_ids = Object.keys(flags);
                                // let new_flags_id = flags_ids.filter((value) => value != key)
                                // this.flag_transaction.forId(this.transaction_id).execute({ flags: new_flags_id });
                            }} className='tag-orange' style={{ marginRight: 6, marginBottom: 4 }}>{item.label}</Tag>
                        })}
                        <Tag title="Add New Label" className='dashed-tag hand-cursor'
                            onClick={() => {
                                typeof this.props.onAssignLabelClicked === 'function' &&
                                    this.props.onAssignLabelClicked(data.id, data)
                                // this.setState({
                                //     flag_form_visibility: true,
                                //     flag_data: {
                                //         flags: Object.keys(flags)
                                //     }
                                // })
                            }}
                            style={{ marginRight: 6, marginBottom: 4 }}>+</Tag>
                    </div>
                </div>

                {reconcilers.map((item, reconciler_index) => {
                    let reconciled_summary = item.reconciled_summary || {};
                    let unreconciled_summary = item.unreconciled_summary || {}
                    return <React.Fragment>
                        <div style={{
                            paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING,
                            paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                            borderBottom: `1px solid ${COLORS.border_basic}`,
                        }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingRight: 10
                                }}>
                                    <Link to={{
                                        pathname: `/processors/groups/${this.props.group_id}/sources/${data.id}`,
                                        search: `tab=${item.id}`
                                    }}>
                                        <div className='sub-heading-3'>{item.name}</div>
                                    </Link>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        marginTop: 6
                                    }}>
                                        <div className='sub-heading-4' style={{
                                            color: COLORS.secondary
                                        }}>Last Processed At: &nbsp;</div>

                                        {moment().format("YYYY-MM-DD") == item.last_reconciled_at ?
                                            <div className='sub-heading-4' style={{
                                                color: COLORS.success_primary,
                                            }}>{item.last_reconciled_at}</div>
                                            : <div className='sub-heading-4'>{item.last_reconciled_at}<span style={{
                                                color: COLORS.success_primary,
                                                marginLeft: 6
                                            }}>({moment().diff(moment(item.last_reconciled_at), 'days')} days ago)</span></div>
                                        }
                                    </div>
                                </div>

                                <ArrowForwardIos
                                    className='hand-cursor'
                                    titleAccess="Expand/Collapse"
                                    onClick={() => {
                                        this.onExpand(reconciler_index);
                                    }}
                                    style={{
                                        color: COLORS.secondary,
                                        transform: `rotate(${expanded_indexes.includes(reconciler_index) ? 90 : 0}deg)`,
                                        transition: 'all 0.2s'
                                    }} />
                            </div>
                        </div>

                        {expanded_indexes.includes(reconciler_index) ?
                            <div style={{
                                backgroundColor: ' rgba(0,0,0,0.02)',
                                boxShadow: 'inset 0px 8px 10px -6px rgba(0,0,0,0.1), inset 0px -8px 10px -6px rgba(0,0,0,0.1)'
                            }}>
                                <div style={{
                                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING,
                                    paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                                    borderBottom: `1px solid ${COLORS.border_basic}`,
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div className='sub-heading-2'>Unprocessed</div>
                                        <Link to={`/processors/groups/${this.props.group_id}/sources/${data.id}/reconcilers/${item.id}/unreconciled`}>
                                            <span className='sub-heading-4' style={{ color: COLORS.danger_primary }}>VIEW ALL</span>
                                        </Link>

                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        paddingTop: 14
                                    }}>
                                        <CountAmountStatsSmall
                                            label="OUR"
                                            count={formatMoney(unreconciled_summary.our_count, 0)}
                                            countStyles={{
                                                color: COLORS.secondary
                                            }}
                                            amount={unreconciled_summary.our_amount}
                                        />
                                        <CountAmountStatsSmall
                                            label="THEIR"
                                            count={formatMoney(unreconciled_summary.their_count, 0)}
                                            amount={unreconciled_summary.their_amount}
                                            containerStyle={{
                                                alignItems: 'flex-end'
                                            }}
                                            countStyles={{
                                                color: COLORS.secondary
                                            }}

                                        />
                                    </div>
                                </div>

                                <div style={{
                                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING,
                                    paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                                    borderBottom: `1px solid ${COLORS.border_basic}`,
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <div className='sub-heading-2'>Processed(Last 7 days)</div>
                                        <Link to={{
                                            pathname: `/processors/groups/${this.props.group_id}/sources/${data.id}/reconcilers/${item.id}/reconciled`,
                                            search: queryString.stringify({
                                                dateFrom: moment().subtract({ days: 6 }).format("YYYY-MM-DD"),
                                                dateTo: moment().format("YYYY-MM-DD")
                                            })
                                        }}>
                                            <span className='sub-heading-4' style={{ color: COLORS.success_primary }}>VIEW ALL</span>
                                        </Link>

                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        paddingTop: 14
                                    }}>
                                        <CountAmountStatsSmall
                                            label="OUR"
                                            count={formatMoney(reconciled_summary.our_count, 0)}
                                            countStyles={{
                                                color: COLORS.secondary
                                            }}
                                            amount={reconciled_summary.our_amount}
                                        />
                                        <CountAmountStatsSmall
                                            label="THEIR"
                                            count={formatMoney(reconciled_summary.their_count, 0)}
                                            amount={reconciled_summary.their_amount}
                                            containerStyle={{
                                                alignItems: 'flex-end'
                                            }}
                                            countStyles={{
                                                color: COLORS.secondary
                                            }}

                                        />
                                    </div>
                                </div>

                            </div> : null}
                    </React.Fragment>
                })}



                {/* <div style={{
                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING,
                    paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                    // borderBottom: `1px solid ${COLORS.border_basic}`,
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginBottom: 5
                    }}>
                        <div className='sub-heading-4' style={{
                            color: COLORS.secondary
                        }}>Last Txn Date:</div>
                        
                                {moment().format("YYYY-MM-DD")==data.last_txn_date?
                                        <div className='sub-heading-4' style={{
                                            color: COLORS.success_primary,
                                        }}>{data.last_txn_date}</div>
                                        :<div className='sub-heading-4'>{data.last_txn_date}<span style={{
                                            color: COLORS.success_primary,
                                            marginLeft: 6
                                        }}>({moment().diff(moment(data.last_txn_date),'days')} days ago)</span></div>
                                        }
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}>
                        <div className='sub-heading-4' style={{
                            color: COLORS.secondary
                        }}>Last Transferred Date:</div>
                        {moment().format("YYYY-MM-DD")==data.last_transferred_at?
                                        <div className='sub-heading-4' style={{
                                            color: COLORS.success_primary,
                                        }}>{data.last_transferred_at}</div>
                                        :<div className='sub-heading-4'>{data.last_transferred_at}<span style={{
                                            color: COLORS.success_primary,
                                            marginLeft: 6
                                        }}>({moment().diff(moment(data.last_transferred_at),'days')} days ago)</span></div>
                                        }
                    </div>
                </div>
             */}
            </div>
        );
    }
}

export default SourceMapItem;
